import { useDeviceType } from "@hook/useDeviceType";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyle } from "./style";

interface IParams {
    description: string;
    onOpenRemoveAddonModal(): void;
}

export const ActiveAddonStatus = (props: IParams) => {
    const { description, onOpenRemoveAddonModal } = props;
    const { classes } = useStyle({});
    const { t } = useTranslation("addons");
    const { isMobile } = useDeviceType();

    return (
        <div className={classes.centeredContainer}>
            <Button fullWidth={isMobile} variant="outlined" onClick={onOpenRemoveAddonModal}>
                {t("cancelAddon", { description })}
            </Button>
        </div>
    );
};
